import { useAuth } from './useAuthFixed';
import liffManager from '../lib/liff';
import { isDevelopmentMode } from '../lib/mockData';

interface LineLoginGuardResult {
  isChecking: boolean;
  isLineLoggedIn: boolean;
  liffError: string | null;
  promptLogin: () => Promise<void>;
}

/**
 * LINEログイン状態をチェックするガードフック
 * AppReadyGate外のページ（/link_token, /consent）で使用
 */
export const useLineLoginGuard = (): LineLoginGuardResult => {
  const { isLoading, error } = useAuth();

  // 開発モード時: ?_guard=liffError / ?_guard=notLoggedIn でエラー状態をシミュレート
  if (isDevelopmentMode()) {
    const params = new URLSearchParams(window.location.search);
    const guard = params.get('_guard');
    if (guard === 'liffError') {
      return {
        isChecking: false,
        isLineLoggedIn: false,
        liffError: 'Simulated LIFF initialization error',
        promptLogin: async () => {},
      };
    }
    if (guard === 'notLoggedIn') {
      return {
        isChecking: false,
        isLineLoggedIn: false,
        liffError: null,
        promptLogin: async () => { console.log('[Dev] promptLogin called'); },
      };
    }
  }

  if (isLoading) {
    return {
      isChecking: true,
      isLineLoggedIn: false,
      liffError: null,
      promptLogin: async () => {},
    };
  }

  if (error) {
    return {
      isChecking: false,
      isLineLoggedIn: liffManager.isLoggedIn(),
      liffError: error,
      promptLogin: async () => {},
    };
  }

  const loggedIn = liffManager.isLoggedIn();

  return {
    isChecking: false,
    isLineLoggedIn: loggedIn,
    liffError: null,
    promptLogin: () => liffManager.login(),
  };
};
